(function (angular) {
    'use strict';

    angular.module('profiles')
        /**
         *
         */
        .controller('profilesCtrl', ['$scope', '$cookies', '$filter', 'NgTableParams', '$stateParams', 'profilesService', '$state', 'profileSchema', '$rootScope', 'jwtService', '$uibModal', '$timeout', 'profileHelper', 'localStorageService', 'coreDataService',
            function ($scope, $cookies, $filter, ngTableParams, $stateParams, profilesService, $state, profileSchema, $rootScope, jwtService, $uibModal, $timeout, profileHelper, localStorageService, coreDataService) {
                $scope.profileSchema = profileSchema;
                $scope.sorting = $stateParams.sorting ? $stateParams.sorting : { _createdOn: "asc" };
                $scope.criteria = $stateParams.criteria;
                $scope.profilesData = [];
                $scope.cols = [];

                createCols();

                $scope.getProfileValue = function (singleProfile, field) {
                    var splitField = field.split('.');
                    var optIn = false;
                    var profile = singleProfile;
                    for (var i in splitField) {
                        if (profile[splitField[i]] || typeof profile[splitField[i]] === 'boolean') {
                            profile = profile[splitField[i]];
                            if (splitField[i] === "_optIn") {
                                optIn = true;
                            }
                        }
                        else {
                            profile = optIn ? 'false' : '';
                            break;
                        }
                    }
                    return profile;
                };

                $scope.move = function move(column, currentIdx, value) {
                    var newPosition = currentIdx + value;
                    if (newPosition >= $scope.cols.length || newPosition < 0) {
                        return;
                    }
                    $scope.cols[currentIdx] = $scope.cols[newPosition];
                    $scope.cols[newPosition] = column;
                    localStorageService.setObject('customTableData_' + $stateParams.pickedApiSpaceId + '_' + jwtService.payload.userId, $scope.cols);
                };

                function createCols() {
                    //<---  13.02.2018 avoiding braking changes for customers using old $cookies solution, can be removed in future
                    var dataFromCookies = $cookies.getObject('customTableData_' + $stateParams.pickedApiSpaceId + '_' + jwtService.payload.userId);

                    if (dataFromCookies) {
                        localStorageService.setObject('customTableData_' + $stateParams.pickedApiSpaceId + '_' + jwtService.payload.userId, dataFromCookies);
                        $cookies.remove('customTableData_' + $stateParams.pickedApiSpaceId + '_' + jwtService.payload.userId);
                    }
                    // --->

                    var customTableData = localStorageService.getObject('customTableData_' + $stateParams.pickedApiSpaceId + '_' + jwtService.payload.userId);

                    if (!customTableData || customTableData.length === 0) {
                        customTableData = [{
                            field: "id", title: "Profile id", sortable: "id", headerTemplateURL: "components/toolkit/profiles/templates/tableHeader.html", show: true
                        },
                        { field: "firstName", title: "First Name", sortable: "firstName", headerTemplateURL: "components/toolkit/profiles/templates/tableHeader.html", show: true },
                        { field: "lastName", title: "Last Name", sortable: "lastName", headerTemplateURL: "components/toolkit/profiles/templates/tableHeader.html", show: true },
                        { field: "phoneNumber", title: "Phone Number", sortable: "phoneNumber", headerTemplateURL: "components/toolkit/profiles/templates/tableHeader.html", show: true },
                        { field: "email", title: "Email", sortable: "email", headerTemplateURL: "components/toolkit/profiles/templates/tableHeader.html", show: true },
                        { field: "_createdOn", title: "Created", sortable: "_createdOn", headerTemplateURL: "components/toolkit/profiles/templates/tableHeader.html", show: true },
                        { field: "_updatedOn", title: "Updated", sortable: "_updatedOn", headerTemplateURL: "components/toolkit/profiles/templates/tableHeader.html", show: true }
                        ];
                    }

                    $scope.cols = customTableData;

                    if ($scope.profileSchema && $scope.profileSchema.length > 0) {
                        $scope.allCols = [];
                        var propertyIsInCookies;
                        $scope.profileSchema.forEach(function (property) {
                            propertyIsInCookies = customTableData.find(function (el) {
                                return el.field == property.path;
                            });
                            if (propertyIsInCookies) {
                                $scope.allCols.push({
                                    field: propertyIsInCookies.field,
                                    title: property.name,
                                    sortable: propertyIsInCookies.sortable,
                                    headerTemplateURL: "components/toolkit/profiles/templates/tableHeader.html",
                                    show: true
                                });
                            } else {
                                $scope.allCols.push({
                                    field: property.path,
                                    title: property.name,
                                    sortable: property.path,
                                    headerTemplateURL: "components/toolkit/profiles/templates/tableHeader.html",
                                    show: false
                                });
                            }
                        });
                    } else {
                        $scope.allCols = customTableData;
                    }

                }

                $scope.createCols = createCols;

                $scope.changeCols = function changeCols(index) {
                    if ($scope.allCols[index].show) {
                        $scope.cols.push($scope.allCols[index]);
                    } else {

                        var indexOfCol = $scope.cols.map(function (e) { return e.field; }).indexOf($scope.allCols[index].field);

                        if (indexOfCol != -1) {
                            $scope.cols.splice(indexOfCol, 1);
                        }
                        limitQuery($scope.allCols[index].title);
                    }
                    localStorageService.setObject('customTableData_' + $stateParams.pickedApiSpaceId + '_' + jwtService.payload.userId, $scope.cols);
                };

                function limitQuery(title) {
                    if ($scope.properties.length > 1) {
                        var requiredPropertyIndex = $scope.properties.map(function (e) {
                            return e.selector;
                        }).indexOf(title);
                        if (requiredPropertyIndex !== -1) {
                            $scope.properties.splice(requiredPropertyIndex, 1);
                        }
                    }
                }
                $scope.properties = [{
                    selector: "",
                    logic: "=~^",
                    value: ""
                }];

                $scope.queryForm = {};

                if ($stateParams.pickedCriteria) {
                    $scope.pickedCriteria = $stateParams.pickedCriteria;
                }


                $scope.clearSearch = function () {
                    var params = $stateParams;
                    params.criteria = null;
                    params.pickedCriteria = null;
                    $state.go('.', params);
                };
                $scope.doSearch = function () {
                    var params = $stateParams;
                    params.criteria = profileHelper.getExtension($scope.properties);
                    params.sorting = $scope.sorting;
                    params.pickedCriteria = $scope.pickedCriteria;
                    $state.go('.', params);
                };


                $scope.exportData = function () {
                    var fields = [];
                    for (var i in $scope.profileSchema) {
                        if (!$scope.profileSchema[i].onlyObjects) {
                            fields.push($scope.profileSchema[i].path);
                        }
                    }
                    var options = {
                        format: "csv",
                        fields: fields,
                        fieldSeparator: ",",
                        includeHeaders: true
                    };
                    $rootScope.$broadcast('fileDownload', { url: "/apispaces/" + $stateParams.pickedApiSpaceId + "/profiles/export?" + $stateParams.criteria, token: jwtService.token, fileName: "profileExport.csv", data: options, httpVerb: "POST" });
                };
                //Sorting
                $scope.tableSorting = new ngTableParams({
                    page: 1,            // show first page
                    count: 10,           // count per page
                    sorting: $scope.sorting
                }, {
                        total: $scope.profilesData.length, // length of data
                        getData: function ($defer, params) {
                            // use build-in angular filter
                            var orderedData = params.sorting() ? $filter('orderBy')($scope.profilesData, params.orderBy()) : $scope.profilesData;
                            $scope.sorting = params.sorting();
                            $defer.resolve(orderedData.slice((params.page() - 1) * params.count(), params.page() * params.count()));
                            params.total(orderedData.length);
                        }
                    });

                $scope.open = function ($event, calendar) {
                    $event.preventDefault();
                    $event.stopPropagation();
                    calendar.opened = true;
                };

                $scope.checkSelector = function (index) {
                    return profileHelper.checkSelector($scope.properties[index]);
                };

                $scope.getProfiles = function () {
                    $scope.pickedApiSpaceId = $stateParams.pickedApiSpaceId;
                    if ($stateParams.criteria) {
                        $scope.properties = profileHelper.getCriteria($stateParams.criteria);
                        return profilesService.getProfilesWithQueries($scope.pickedApiSpaceId, $stateParams.criteria).then(function (response) {
                            $scope.profilesData = response;
                            $scope.profilesCount = response.length;
                            return profilesService.getProfilesCount($stateParams.pickedApiSpaceId, $stateParams.criteria).then(function (result) {
                                $scope.numberOfPossibleProfiles = result;
                                return true;
                            }).catch(function (err) {
                                return false;
                            });
                        }).catch(function (err) {
                            return false;
                        });
                    }
                    else {
                        return profilesService.getProfiles($scope.pickedApiSpaceId).then(function (response) {
                            $scope.profilesData = response;
                            $scope.profilesCount = response.length;
                            return profilesService.getProfilesCount($stateParams.pickedApiSpaceId).then(function (result) {
                                $scope.numberOfPossibleProfiles = result;
                                return true;
                            }).catch(function (err) {
                                return false;
                            });
                        }).catch(function (err) {
                            return false;
                        });
                    }
                };
                $scope.getProfiles().then(function () {
                    $scope.tableSorting.reload();
                });


                $scope.saveAudience = function () {

                    var modalInstance = $uibModal.open({
                        animation: true,
                        templateUrl: 'components/toolkit/profiles/templates/saveAudienceModal.html',
                        controller: 'saveAudienceModal',
                        resolve: {
                            criteria: function () {
                                return profileHelper.getExtension($scope.properties);
                            },
                            pickedCriteria: function () {
                                return $scope.pickedCriteria;
                            }
                        }
                    });

                    modalInstance.result.then(function (criteria) {
                        var params = $stateParams;
                        params.criteria = criteria.query;
                        params.pickedCriteria = criteria;
                        params.sorting = $scope.sorting;
                        $state.go('.', params);

                    });
                };


                $scope.importData = function () {
                    var modalInstance = $uibModal.open({
                        animation: true,
                        templateUrl: 'components/toolkit/profiles/templates/importDataModal.html',
                        controller: 'uploadModal',
                        size: 'lg',
                        resolve: {
                            profileSchema: function () {
                                return $scope.profileSchema;
                            },
                            allowOtherProperties: function () {
                                return $scope.allowOtherProperties;
                            },
                            countries: function () {
                                return coreDataService.getCountries()
                                    .then(function (result) {
                                        return result;
                                    });
                            }
                        }
                    });
                };

                $scope.addProfile = function () {
                    var modalInstance = $uibModal.open({
                        animation: true,
                        templateUrl: 'components/toolkit/profiles/templates/addProfileModal.html',
                        controller: 'addProfileModal',
                        size: 'lg',
                        resolve: {
                            profileSchema: function () {
                                return $scope.profileSchema;
                            },
                            allowOtherProperties: function () {
                                return $scope.allowOtherProperties;
                            }
                        }
                    });

                    modalInstance.result.then(function (data) {
                        if ($scope.allowOtherProperties) {
                            profilesService.getProfileSchema($stateParams.pickedApiSpaceId)
                                .then(function (result) {
                                    $scope.profileSchema = profileHelper.setSchema(result);
                                });
                        }
                    });
                };





            }]).controller('saveAudienceModal', ['$scope', '$stateParams', 'audiencesService', '$uibModalInstance', 'criteria', 'pickedCriteria', 'growlService', function ($scope, $stateParams, audiencesService, $uibModalInstance, criteria, pickedCriteria, growlService) {
                $scope.pickedCriteria = pickedCriteria;
                if ($scope.pickedCriteria) {
                    $scope.name = $scope.pickedCriteria.name;
                    $scope.description = $scope.pickedCriteria.description;
                    $scope.isTest = $scope.pickedCriteria.isTest;
                }
                $scope.save = function () {
                    var data = {
                        name: $scope.name,
                        description: $scope.description,
                        query: criteria,
                        isTest: $scope.isTest

                    };
                    audiencesService.createAudience($stateParams.pickedApiSpaceId, data).then(function (result) {
                        growlService.success('Audience successfully saved.');
                        $uibModalInstance.close(result);
                    }).catch(function (error) {
                        growlService.danger("Audience wasn't created due to: " + error.statusText);
                    });
                };
                $scope.overwrite = function () {
                    var data = {
                        id: pickedCriteria.id,
                        name: $scope.name,
                        description: $scope.description,
                        query: criteria,
                        isTest: $scope.isTest
                    };
                    audiencesService.updateAudience($stateParams.pickedApiSpaceId, data).then(function (result) {
                        growlService.success('Audience successfully saved.');
                        $uibModalInstance.close(result);
                    }).catch(function (error) {
                        growlService.danger("Audience wasn't updated due to: " + error.statusText);
                    });
                };
                $scope.cancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };
            }]);
})(window.angular);